import React from "react";

interface ChangedValueProps {
    oldValue: any;
    newValue: any;
    showChange: boolean;
    formatter?: (value: any) => string;
}

const ChangedValue: React.FC<ChangedValueProps> = React.memo(props => {

    const format = props.formatter ?? (m => m?.toString());

    return !props.showChange || props.oldValue === props.newValue
        ? <>{format(props.oldValue)}</>
        : <>
            <span className="old-value">{format(props.oldValue)}</span>
            <span className="new-value">{format(props.newValue)}</span>
        </>
});

export default ChangedValue;